import React, { Component } from "react";
import logo from "./logo.png";
//import CartecFooter from "./CartecFooter";
export default class UserInfo extends Component {
    state = {
        data: ['Motorhaube',
            'Kotflugel V.L.',
            '  Kotflugel V.R.',
            'Ture V.L.',
            ' Ture H.L.',
            'Ture V.R.',
            ' Ture H.R.',
            'Seitenwand H.L.',
            'Seitenwand H.R.',
            ' Kofferdeckel',
            'Dach',
            ' Dachrand L.',
            ' Dachrand R.',
            'Schiebedach',
            ' WindlaufVo'
        ]
    }
    render() {
        const userSession = localStorage.getItem("userSession");
        const data = userSession ? JSON.parse(userSession) : {};
        var d = new Date();
        var today = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getUTCFullYear()
        return (
            <>
                <div className="container p-0">
                    <div className="d-list-middle row p-0">
                        <div className="main-heading-general col-12 p-0">
                            {/* <h3>Auftrag I Reparaturkostenberechnung <span> Hagelschaden</span> </h3> */}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0">
                            <div className="row p-0 first-row">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Datum</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{today}</div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Auftraqs-Nr.</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">- </div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Schaden-Nr.</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.Datetime || '-'}</div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Termin</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.Datetime || '-'}</div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Km</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">- </div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Versicherung</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light"> - </div>
                            </div>
                            <div className="row new-row p-0">
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Kotrollschild</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light"> - </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0">
                            <div className="row p-0 first-row">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Marke</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.manufacturer || '-'}</div>
                            </div>
                            <div className="row new-row p-0">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Typ</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.model || '-'}</div>
                            </div>
                            <div className="row new-row p-0">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">1. lnverkehrssetzung</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light"> - </div>
                            </div>
                            <div className="row new-row p-0">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Chassis Nr.</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{localStorage.getItem("selectedFile")}</div>
                            </div>
                            <div className="row new-row p-0">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Name</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.Name || '-'}</div>
                            </div>
                            <div className="row new-row p-0">
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-5 col-md-11 col-sm-12 text-heading-bold">Adresse</div>
                                {/* <div className="col-lg-1 col-md-11 col-sm-12"></div> */}
                                <div className="col-lg-6 col-md-11 col-sm-12 text-heading-light">{data.street || '-'} </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </>
        );
    }
}